import { OnInit } from '@angular/core';
import { ManagedClient } from 'app/shared/models/managed-client';
import { AlertService } from 'app/shared/services/alert.service';
import { AuthService } from 'app/login/services/auth.service';
import { DacConfig } from 'app/shared/services/dac-config.service';
import { ClientService } from 'app/shared/services/client.service';
import { MessageTemplateService } from 'app/admin/services/message-template.service';
var ClientSendInvitationComponent = /** @class */ (function () {
    function ClientSendInvitationComponent(alertService, authService, dacConfig, clientService, messageTemplateService) {
        this.alertService = alertService;
        this.authService = authService;
        this.dacConfig = dacConfig;
        this.clientService = clientService;
        this.messageTemplateService = messageTemplateService;
        this.emailSubject = "Loading...";
        this.emailMessage = "Loading...";
        // let originalSubject =  "Discover and Change - Assessment Portal Information";
        // this.emailSubject = originalSubject;
        // this.authService.getCurrentUser().then(user => {
        //   this.user = user;
        //   if (this.emailSubject == originalSubject && this.user.companyName) {
        //     this.emailSubject = "Assessment Portal Information - " + this.user.companyName;
        //   }
        //   this.setupEmailMessage();
        // });
        this.confirmEmail = false;
    }
    ClientSendInvitationComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.client) {
            this.failMessageTemplateLoad(new Error("No client set for this invitation"));
        }
        this.toEmailAddress = this.client.email;
        this.messageTemplateService.getMessageForClient(this.client).then(function (msgTemplate) {
            if (msgTemplate.subject) {
                _this.emailSubject = msgTemplate.subject;
            }
            else {
                _this.emailSubject = "";
            }
            if (msgTemplate.message) {
                _this.emailMessage = msgTemplate.message;
            }
            else {
                _this.emailMessage = "";
            }
            if (msgTemplate.replyTo) {
                _this.replyToEmailAddress = msgTemplate.replyTo;
            }
            if (msgTemplate.testEmail) {
                _this.testEmailAddress = msgTemplate.testEmail;
            }
            if (msgTemplate.to) {
                _this.toEmailAddress = msgTemplate.to;
            }
            if (msgTemplate.from) {
                _this.fromEmailAddress = msgTemplate.from;
            }
        })
            .catch(function (error) {
            _this.failMessageTemplateLoad(error);
        });
    };
    ClientSendInvitationComponent.prototype.failMessageTemplateLoad = function (error) {
        console.error(error);
        this.alertService.error("We failed to retrieve the email template from the server.  Check your internet connection and try to refresh the page.");
        this.emailMessage = "Server Error - Failed to load";
        this.emailSubject = "Server Error - Failed to load";
    };
    Object.defineProperty(ClientSendInvitationComponent.prototype, "supportEmail", {
        get: function () {
            return this.dacConfig.supportEmail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClientSendInvitationComponent.prototype, "sender", {
        get: function () {
            return this.user ? this.user.username : this.dacConfig.supportEmail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClientSendInvitationComponent.prototype, "companyName", {
        //   private setupEmailMessage() {
        //     let message = `Hi ${this.client.getDisplayString()},
        // I've created a unique code for you to use to take your assessments.
        // The identifier you'll use to login is: ${this.client.customField1}
        // You can take your assessments here: ${this.siteURL}`;
        //     this.emailMessage = message;
        //   }
        get: function () {
            if (this.user) {
                return this.user.companyName;
            }
            return "";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClientSendInvitationComponent.prototype, "userEmail", {
        get: function () {
            if (this.user) {
                return this.user.username;
            }
            return "";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClientSendInvitationComponent.prototype, "siteURL", {
        get: function () {
            return this.dacConfig.take_test_url;
        },
        enumerable: true,
        configurable: true
    });
    ClientSendInvitationComponent.prototype.sendEmail = function () {
        this.confirmEmail = true;
    };
    ClientSendInvitationComponent.prototype.confirmEmailSend = function () {
        this.sendEmailToServer(false);
    };
    ClientSendInvitationComponent.prototype.sendTestEmail = function () {
        this.sendEmailToServer(true);
    };
    ClientSendInvitationComponent.prototype.sendEmailToServer = function (isTest) {
        var _this = this;
        if (!this.emailSubject || !this.emailSubject.trim()) {
            this.alertService.error("Email subject must not be empty");
        }
        if (!this.emailMessage || !this.emailMessage.trim()) {
            this.alertService.error("Email message must not be empty");
        }
        this.clientService.sendClientEmail(this.client.id, this.emailSubject, this.emailMessage, isTest)
            .then(function () {
            _this.alertService.success("Email sent!");
            _this.confirmEmail = false;
        })
            .catch(function () {
            _this.alertService.error("The email failed to send. Check your connection and try again.  Or contact support");
        });
    };
    ClientSendInvitationComponent.prototype.copyText = function () {
        try {
            var copyTextarea = document.getElementById('clientEmailTemplate');
            copyTextarea.select();
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
            this.alertService.success("Message Copied To Clipboard!");
        }
        catch (err) {
            this.alertService.error("Uh Oh! Looks like your browser doesn't support this feature.  Highlight the text and press Ctrl+C or CMD+C", 5000);
        }
    };
    return ClientSendInvitationComponent;
}());
export { ClientSendInvitationComponent };



// WEBPACK FOOTER //
// ./src/app/client-send-invitation/client-send-invitation.component.ts.pre-build-optimizer.js